/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";
import {
  Card,
  CardHeader,
  CardContent,
  CircularProgress,
  Typography,
  Tabs,
  Tab
} from "@material-ui/core";
import { MapContainer, TileLayer } from "react-leaflet";
import MapContent from "./MapContent";
import DownloadMenu from "./DownloadMenu";

const MapCard = ({
  isFetchingMapData,
  markerPoints,
  siteData,
  changeChip,
  tabValue,
  handleTabChange,
  ...props
}) => {
  const center = [50.73, -125.7];

  const RenderMap = () => (
    <MapContainer
      style={{ width: "100%", height: "100%" }}
      center={center}
      zoom={7}
      scrollWheelZoom
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {markerPoints && markerPoints.length > 0 && (
        <MapContent markerPoints={markerPoints} />
      )}
    </MapContainer>
  );

  const RenderProgress = () => (
    <CircularProgress
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      }}
    />
  );

  return (
    <Card>
      <CardHeader
        title={
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="Download Tabs"
          >
            <Tab label="Table" />
            <Tab label="Map" />
            <Tab label="Chart" />
          </Tabs>
        }
        action={
          props.sample.display_name.length ? (
            <span>
              <DownloadMenu {...props} />
            </span>
          ) : null
        }
      />
      <CardContent>
        <Row style={{ marginTop: "1rem" }}>
          <Col xs={12}>
            <div
              style={{
                height: props.showMap ? "600px" : "auto",
                width: "100%",
                position: "relative"
              }}
            >
              {(props.filterChanged || !props.showMap) && (
                <Typography style={{ margin: "5px" }}>
                  <b>
                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                    Click 'LOAD PREVIEW' to refresh data based on your search
                    criteria and display map.
                  </b>
                </Typography>
              )}
              {isFetchingMapData
                ? RenderProgress()
                : props.showMap && RenderMap()}
            </div>
          </Col>
        </Row>
      </CardContent>
    </Card>
  );
};

MapCard.propTypes = {
  isFetchingMapData: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  markerPoints: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  siteData: PropTypes.object.isRequired,
  changeChip: PropTypes.func.isRequired,
  filterChanged: PropTypes.bool.isRequired,
  showMap: PropTypes.bool.isRequired,
  tabValue: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired,
  gridIsLoaded: PropTypes.bool.isRequired,
  showGridColumnPicker: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    toggleColumnPicker: PropTypes.func.isRequired
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  sample: PropTypes.shape({ display_name: PropTypes.string }).isRequired
};

export default MapCard;
